import React from 'react';

interface TabPanelProps {
  currentTabIndex: number;
  index: number;
}

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  currentTabIndex,
  index,
}) => <div hidden={currentTabIndex !== index}>{children}</div>;
